export const incident_comment_methods = {
  toggle_comment_panel(id) {
    this.comment_panel_open = {
      ...(this.comment_panel_open || {}),
      [id]: !this.is_comment_panel_open(id),
    };
  },
  is_comment_panel_open(id) {
    return !!Reflect.get(this.comment_panel_open || {}, id);
  },
  toggle_incident_comments(id) {
    this.comments_expanded = {
      ...(this.comments_expanded || {}),
      [id]: !this.are_incident_comments_expanded(id),
    };
  },
  are_incident_comments_expanded(id) {
    return !!Reflect.get(this.comments_expanded || {}, id);
  },
  get_visible_incident_comments(report) {
    const comments = this.get_incident_comments(report);
    return this.are_incident_comments_expanded(report.id)
      ? comments
      : comments.slice(0, 3);
  },
  has_more_incident_comments(report) {
    return this.get_incident_comments(report).length > 3;
  },
  are_incident_replies_expanded(report_id, comment_id) {
    const key = `${report_id}:${comment_id}`;
    return !!Reflect.get(this.comment_replies_expanded || {}, key);
  },
  toggle_incident_replies(report_id, comment_id) {
    const key = `${report_id}:${comment_id}`;
    this.comment_replies_expanded = {
      ...(this.comment_replies_expanded || {}),
      [key]: !this.are_incident_replies_expanded(report_id, comment_id),
    };
  },
  start_incident_comment_reply(report, comment) {
    const mention = `@${this.get_comment_author(comment)} `;
    const current_draft = Reflect.get(this.comment_drafts || {}, report.id) || "";
    this.comment_drafts = {
      ...(this.comment_drafts || {}),
      [report.id]: current_draft || mention,
    };
    this.comment_reply_targets = {
      ...(this.comment_reply_targets || {}),
      [report.id]: comment.id,
    };
    this.$nextTick(() => {
      document.querySelector(`[data-incident-comment-input="${report.id}"]`)?.focus();
    });
  },
  get_incident_comment_display_text(comment, parent_comment = null) {
    const text = this.get_comment_text(comment);
    const author = parent_comment
      ? this.get_comment_author(parent_comment)
      : null;
    return author && text.startsWith(`@${author} `)
      ? text.slice(author.length + 2)
      : text;
  },
};
